import React from "react";
import styles from "./styles.css";
import InfoIcon from "./images/info.svg";
import PropTypes from "prop-types";

const FranchiseInfo = ({ title, description }) => {
    return (
        <div styleName={"styles.franchiseText"}>
            <img src={InfoIcon} alt="info" width={174} height={165} fetchpriority={"low"} />
            <div styleName={"styles.content"}>
                <h3>{title}</h3>
                <div styleName={"styles.description"} dangerouslySetInnerHTML={{ __html: description }} />
            </div>
        </div>
    );
};

FranchiseInfo.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string
};

export default FranchiseInfo;
